const mapFavoritesData = (favorite, t) => {
  if (!favorite || !favorite.itemType || !favorite.itemDetails) {
    return {
      id: favorite?.id || t("unknown"),
      postId: favorite?.itemId || t("unknown"),
      itemType: favorite?.itemType || t("unknown"),
      title: t("post_unavailable", "Post Unavailable"),
      description: t("post_may_have_been_deleted", "This post may have been deleted by its owner."),
      additionalInfo: {},
      isDeleted: true,
    };
  }

  const { itemType, itemDetails } = favorite;

  let mappedData = {
    id: favorite.id,
    postId: favorite.itemId,
    itemType: itemType,
    title: '',
    description: '',
    additionalInfo: {},
    isDeleted: false,
  };

  switch (itemType) {
    case 'PSA':
      mappedData.title = itemDetails.title || t("no_title_available");
      mappedData.description = itemDetails.description || t("no_description_available");
      mappedData.imageUrl = itemDetails.imageUrl || null;
      break;

    case 'Place':
      mappedData.title = itemDetails.name || t("unknown_place");
      mappedData.description = itemDetails.address || t("no_address_available");
      mappedData.additionalInfo = {
        Website: itemDetails.website ? t("website") : null, // Display "Website" text
        WebsiteLink: itemDetails.website || null, // Actual URL for the website
        Address: itemDetails.address ? t("click_to_navigate") : null, // Display "Click to Navigate" text
        AddressLink: itemDetails.address
          ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(itemDetails.address)}`
          : null, // Actual URL for Google Maps
        Phone: itemDetails.phone || null,
      };
      break;

    case 'LostAnimal':
      mappedData.title = itemDetails.animalName || t("unknown_animal");
      mappedData.description = `${t("last_seen")}: ${itemDetails.lastSeen || t("unknown_location")}`;
      mappedData.additionalInfo = {
        Breed: itemDetails.breed || t("unknown_breed"),
        Color: itemDetails.colorMarkings || t("unknown_color"),
      };
      mappedData.animalImageUrl = itemDetails.animalImageUrl || t("no_image_found");
      break;

    case 'FoundAnimal':
      mappedData.title = itemDetails.animalName || t("unknown_animal");
      mappedData.description = `${t("found_near")}: ${itemDetails.foundNear || t("unknown_location")}`;
      mappedData.additionalInfo = {
        Breed: itemDetails.breed || t("unknown_breed"),
        Color: itemDetails.colorMarkings || t("unknown_color"),
      };
      mappedData.animalImageUrl = itemDetails.animalImageUrl || t("no_image_found");
      break;

    case 'PetService':
      mappedData.title = itemDetails.title || t("no_title_available", "No title available");
      mappedData.description = itemDetails.description || t("no_description_available", "No description available");
      mappedData.imageUrl = itemDetails.imageUrl || null;
      break;

    default:
      console.warn(`Unhandled favorite item type: ${itemType}`);
      mappedData.title = t("unknown_item_type");
      mappedData.description = t("details_unavailable");
      break;
  }

  return mappedData;
};

export default mapFavoritesData;